import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { DataGridRadioColumn } from '../../../../util/DataGrid/DataGridHelpers';
import { StripedDataGrid } from '../../../factories/DataGrid/styles/striped';
const debug = process.env.REACT_APP_DEBUG && false;
export const CustomerDataGrid = ({ loading, customers, setSelectedCustomer }) => {
    const columns = [
        DataGridRadioColumn,
        {
            field: 'name',
            headerName: 'Customers',
            flex: 1,
            disableColumnMenu: true,
        },
    ];
    // data grid selection
    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });
    useEffect(() => {
        const selectedIds = 'ids' in rowSelectionModel ? Array.from(rowSelectionModel.ids) : rowSelectionModel;
        setSelectedCustomer(customers.find((c) => c.id === selectedIds[0]));
    }, [rowSelectionModel, customers]);
    // data grid selection
    const dataGridProps = {
        columns,
        loading,
        rows: customers,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        density: 'compact',
        checkboxSelection: true,
        rowSelectionModel,
        onRowSelectionModelChange: setRowSelectionModel,
        hideFooterSelectedRowCount: true,
        disableMultipleRowSelection: true,
        hideFooter: customers.length <= 10,
        hideFooterPagination: customers.length <= 10,
        initialState: { sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }, pagination: { paginationModel: { pageSize: 10 } } },
    };
    debug && console.log('Customer DataGrid produced props ', dataGridProps);
    return (_jsx(Stack, { minWidth: "15em", children: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }) }));
};
